<input (change)="onFileChange($event); fileInput.value = null"
       [accept]="supportedFiles"
       class="d-none"
       hidden #fileInput
       type="file"
/>

<div
    class="whc-form-field cursor-pointer w-100 d-flex justify-content-start align-items-center"
    [class.field-disabled]="control.disabled"
>
    <input (click)="control.markAsTouched(); fileInput.click()"
           [formControl]="fileNameControl"
           type="text"
           class="cursor-pointer"
           readonly [placeholder]="placeholder | translate"
    />
</div>
